import { Pipe, PipeTransform } from '@angular/core';
import { TrendingSeries } from '../../trending-chart.helpers';
import { VisiblePlotBandFeature } from '@store';

@Pipe({
  name: 'matchingPlotBand',
  standalone: true,
})
export class MatchingPlotBandPipe implements PipeTransform {
  transform(input: TrendingSeries, plotBands: VisiblePlotBandFeature[]): VisiblePlotBandFeature {
    const matchingPlotBand = plotBands.find(
      (plotBand) => input.options.id.split('_')[1] === plotBand.feature
    );

    return matchingPlotBand;
  }
}
